import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import del from './del.js'
import quantity from './quantity.js'

export default contract({
  del: array([
    del
  ]),
  quantity: array([
    quantity
  ])
})
